import { TableListSwapsOrReturns } from './TableListSwapsOrReturns'

export default TableListSwapsOrReturns
